import React, { useState, useEffect } from 'react';
import { Menu, X, Play, CheckCircle, Users, Building, CreditCard, FileText, Shield, Zap,Wheat, 
  ChevronRight, Globe, Factory, Heart, ShoppingCart } from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const EngagementModel = () => { 
  const [activeIndustry, setActiveIndustry] = useState('fintech');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };

  const industries = {
    fintech: {
      title: "Fintech",
      icon: CreditCard,
      description: "Digital payment solutions, lending platforms, and financial services",
      majorPlayers: ["PayPal", "Stripe", "Square", "Razorpay", "Paytm", "PhonePe"],
      solutions: [
        { name: "Payment Processing", desc: "Secure transaction processing with real-time validation" },
        { name: "Digital Wallet", desc: "Multi-currency wallet solutions with seamless UX" },
        { name: "Lending Platform", desc: "AI-powered credit scoring and loan management" },
        { name: "Fraud Detection", desc: "Advanced ML algorithms for fraud prevention" }
      ],
      gradient: "from-green-500 to-emerald-500",
      bgGradient: "from-green-50 to-emerald-50"
    },
    banking: {
      title: "Banking",
      icon: Building,
      description: "Core banking systems, digital transformation, and regulatory compliance",
      majorPlayers: ["JPMorgan Chase", "Bank of America", "HDFC Bank", "ICICI Bank", "Wells Fargo"],
      solutions: [
        { name: "Core Banking", desc: "Comprehensive banking infrastructure and operations" },
        { name: "Digital Banking", desc: "Mobile-first banking experiences and services" },
        { name: "Regulatory Compliance", desc: "Automated compliance monitoring and reporting" },
        { name: "Risk Management", desc: "Advanced risk assessment and mitigation tools" }
      ],
      gradient: "from-blue-500 to-cyan-500",
      bgGradient: "from-blue-50 to-cyan-50"
    },
    manufacturing: {
      title: "Manufacturing",
      icon: Factory,
      description: "Industrial IoT, automation, and supply chain optimization",
      majorPlayers: ["General Electric", "Siemens", "Toyota", "Bosch", "Schneider Electric"],
      solutions: [
        { name: "Industrial IoT", desc: "Smart factory solutions with real-time monitoring" },
        { name: "Supply Chain", desc: "End-to-end visibility and optimization tools" },
        { name: "Quality Control", desc: "AI-powered quality assurance and testing" },
        { name: "Predictive Maintenance", desc: "Machine learning for equipment optimization" }
      ],
      gradient: "from-orange-500 to-red-500",
      bgGradient: "from-orange-50 to-red-50"
    },
    healthcare: {
      title: "Healthcare",
      icon: Heart,
      description: "Telemedicine, health records, and medical device integration",
      majorPlayers: ["Johnson & Johnson", "Pfizer", "Roche", "Philips Healthcare", "Siemens Healthineers"],
      solutions: [
        { name: "Telemedicine", desc: "Remote consultation and diagnosis platforms" },
        { name: "Health Records", desc: "Secure electronic health record systems" },
        { name: "Medical Devices", desc: "IoT integration for medical equipment" },
        { name: "Clinical Analytics", desc: "AI-driven insights for better patient outcomes" }
      ],
      gradient: "from-pink-500 to-purple-500",
      bgGradient: "from-pink-50 to-purple-50"
    },
    agriculture: {
  title: "Agriculture",
  icon: Wheat, // or you could use Tractor, Leaf, or Sprout depending on available icons
  description: "Precision farming, crop monitoring, and agricultural supply chain management",
  majorPlayers: ["John Deere", "Cargill", "Monsanto/Bayer", "ADM", "Syngenta", "AGCO"],
  solutions: [
    { name: "Precision Farming", desc: "GPS-guided machinery and variable rate technology for optimized field operations" },
    { name: "Crop Monitoring", desc: "Satellite imagery and IoT sensors for real-time crop health tracking" },
    { name: "Farm Management", desc: "Comprehensive farm planning, record keeping, and compliance tools" },
    { name: "Supply Chain", desc: "End-to-end traceability from farm to consumer with blockchain integration" }
  ],
  gradient: "from-yellow-500 to-green-500",
  bgGradient: "from-yellow-50 to-green-50"
},
    retail: {
      title: "Retail",
      icon: ShoppingCart,
      description: "E-commerce platforms, inventory management, and customer analytics",
      majorPlayers: ["Amazon", "Walmart", "Alibaba", "Shopify", "Target", "Flipkart"],
      solutions: [
        { name: "E-commerce Platform", desc: "Scalable online retail solutions" },
        { name: "Inventory Management", desc: "Real-time stock tracking and optimization" },
        { name: "Customer Analytics", desc: "Behavioral insights and personalization" },
        { name: "Omnichannel", desc: "Unified shopping experience across channels" }
      ],
      gradient: "from-purple-500 to-indigo-500",
      bgGradient: "from-purple-50 to-indigo-50"
    }
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Header */}
      <Header />
      {/* Hero Section - Dark Theme */}
      <section className="bg-gray-900 pt-24 pb-20 relative overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
          <div className="absolute bottom-20 left-1/2 w-80 h-80 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
        </div>
        
        {/* Floating particles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-cyan-400 rounded-full opacity-30 animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="animate-fade-in-up">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                <span className="text-cyan-400 animate-gradient">Technology</span> Infrastructure
                <br />
                that elevates Customer
                <br />
                Experience
              </h1>
              <p className="text-gray-300 text-lg mb-8 animate-fade-in-up animation-delay-200">
                We deliver robust technology infrastructure to
                help businesses deliver exceptional experiences,
                accelerating growth with high-performance processing
                and seamless integration.
              </p>
              <div className="flex flex-wrap gap-6 mb-8 animate-fade-in-up animation-delay-400">
                <div className="text-center">
                  <div className="text-3xl font-bold text-white counter" data-target="500">500+</div>
                  <div className="text-gray-400">Clients</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white counter" data-target="1000">1,000+</div>
                  <div className="text-gray-400">Projects</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white counter" data-target="10">10+</div>
                  <div className="text-gray-400">Years</div>
                </div>
              </div>
            </div>
            
            <div className="relative animate-fade-in-right">
              <div className="bg-gray-800 rounded-2xl shadow-xl p-6 relative z-10 hover:shadow-2xl transition-shadow duration-300 border border-gray-700">
                <div className="w-full aspect-video bg-gradient-to-br from-cyan-100 to-blue-100 rounded-lg flex items-center justify-center mb-4 overflow-hidden">
    <img 
      src="/Fintech.png" 
      alt="Technology Infrastructure" 
      className="w-full h-full object-cover rounded-lg"
    />
  </div>
                <div className="text-center">
                  <h3 className="text-xl font-semibold text-white mb-2">Modern Solutions</h3>
                  <p className="text-gray-400 text-sm">Scalable and reliable technology platform</p>
                </div>
              </div>
              
              {/* Award Badge */}
              <div className="absolute -bottom-4 -right-4 bg-cyan-500 text-white p-4 rounded-full animate-bounce-slow z-20">
                <div className="text-center">
                  <div className="text-xs font-semibold">Best</div>
                  <div className="text-xs">Tech</div>
                  <div className="text-xs">2024</div>
                </div>
              </div>
              
              {/* Floating Cards */}
              <div className="absolute -top-4 -left-4 bg-gray-800 border border-gray-700 rounded-lg shadow-lg p-4 max-w-xs animate-float z-20">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center">
                    <Zap className="text-white animate-pulse" size={20} />
                  </div>
                  <div>
                    <div className="font-semibold text-white">Performance</div>
                    <div className="text-sm text-gray-400">99.9% Uptime</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> 
      {/* Hero Section */}
      {/* Industries We Serve Section */}
      <section id="industries" className="py-5 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-2">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 animate-fade-in-up">
              Industries <span className="text-cyan-500">We Serve</span>
            </h2>
            {/* <p className="text-gray-600 text-lg animate-fade-in-up animation-delay-200">
              Empowering businesses across diverse sectors with cutting-edge technology solutions
            </p> */}
          </div>

          {/* Industry Tabs */}
          <div className="flex flex-wrap justify-center mb-12 gap-2">
            {Object.entries(industries).map(([key, industry]) => (
              <button
                key={key}
                onClick={() => setActiveIndustry(key)}
                className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all duration-300 ${
                  activeIndustry === key 
                    ? `bg-gradient-to-r ${industry.gradient} text-white shadow-lg transform scale-105` 
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                <industry.icon size={20} />
                <span className="font-medium">{industry.title}</span>
              </button>
            ))}
          </div>

          {/* Active Industry Content */}
          <div className={`bg-gradient-to-br ${industries[activeIndustry].bgGradient} rounded-3xl p-8 md:p-12 relative overflow-hidden`}>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
              <div className="absolute bottom-10 left-10 w-80 h-80 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
            </div>

            <div className="relative z-10">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div className="animate-fade-in-left">
                  <div className="flex items-center gap-4 mb-6">
                    <div className={`w-16 h-16 bg-gradient-to-br ${industries[activeIndustry].gradient} rounded-xl flex items-center justify-center`}>
                      {/* <industries[activeIndustry].icon className="text-white" size={32} /> */}
                    </div>
                    <div>
                      <h3 className="text-3xl font-bold text-gray-900">{industries[activeIndustry].title}</h3>
                      <p className="text-gray-600">{industries[activeIndustry].description}</p>
                    </div>
                  </div>

                  {/* <div className="mb-8">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">Major Players We Work With</h4>
                    <div className="flex flex-wrap gap-2">
                      {industries[activeIndustry].majorPlayers.map((player, index) => (
                        <span key={index} className="bg-white px-4 py-2 rounded-full text-sm font-medium text-gray-700 shadow-sm">
                          {player}
                        </span>
                      ))}
                    </div>
                  </div> */}

                  <button className={`bg-gradient-to-r ${industries[activeIndustry].gradient} text-white px-8 py-3 rounded-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-semibold`}>
                    Explore {industries[activeIndustry].title} Solutions
                  </button>
                </div>

                <div className="animate-fade-in-right">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {industries[activeIndustry].solutions.map((solution, index) => (
                      <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                        <h5 className="font-semibold text-gray-900 mb-2">{solution.name}</h5>
                        <p className="text-sm text-gray-600">{solution.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      
    {/* Solutions Section - Dark Theme */}
      <section id="solutions" className="py-20 bg-gray-900 relative overflow-hidden">
        {/* Background Animation */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 right-10 w-64 h-64 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-10 left-10 w-80 h-80 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 animate-fade-in-up">
              Our <span className="text-cyan-400">Solutions</span>
            </h2>
            <p className="text-gray-300 text-lg animate-fade-in-up animation-delay-200">Range of products for better user experience</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-800 border border-gray-700 rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-left">
              <div className="mb-4 overflow-hidden rounded-lg">
                <div className="w-full h-32 bg-gradient-to-br from-cyan-800 to-blue-800 flex items-center justify-center transition-transform duration-300 hover:scale-105">
                  <CreditCard className="text-cyan-400" size={48} />
                </div>
              </div>
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center mb-6">
                <CreditCard className="text-white" size={24} />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Digital Solutions</h3>
              <p className="text-gray-300 mb-6">Full-stack digital transformation solutions that help businesses modernize their operations and enhance customer experiences.</p>
              <button className="bg-cyan-500 text-white px-6 py-3 rounded-lg hover:bg-cyan-600 transition-colors font-semibold transform hover:scale-105">
                Explore Solutions
              </button>
            </div>
            
            <div className="bg-gray-800 border border-gray-700 rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-right">
              <div className="mb-4 overflow-hidden rounded-lg">
                <div className="w-full h-32 bg-gradient-to-br from-green-800 to-emerald-800 flex items-center justify-center transition-transform duration-300 hover:scale-105">
                  <Zap className="text-green-400 animate-pulse" size={48} />
                </div>
              </div>
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mb-6">
                <Zap className="text-white animate-pulse" size={24} />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Performance Solutions</h3>
              <p className="text-gray-300 mb-6">High-performance computing solutions designed to handle complex workloads and deliver exceptional speed and reliability.</p>
              <button className="bg-cyan-500 text-white px-6 py-3 rounded-lg hover:bg-cyan-600 transition-colors font-semibold transform hover:scale-105">
                Explore Solutions
              </button>
            </div>
          </div>
        </div>
      </section>
       <section id="platform" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 animate-fade-in-up">
              Anvitech <span className="text-cyan-500">Embedded Technology Platform</span>
            </h2>
            <p className="text-gray-600 text-lg animate-fade-in-up animation-delay-200">We are streamlining next-generation API, SDK and Plug N Play</p>
          </div>
          
          <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="grid md:grid-cols-3 gap-8 items-center relative z-10">
              <div className="space-y-6">
                {[
                  { icon: Shield, title: "Switching", description: "Advanced switching solutions", color: "bg-cyan-500" },
                  { icon: FileText, title: "Middleware", description: "Seamless integration layer", color: "bg-blue-500" },
                  { icon: Building, title: "Core", description: "Robust core infrastructure", color: "bg-indigo-500" }
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-4 animate-slide-in-left" style={{animationDelay: `${index * 200}ms`}}>
                    <div className={`w-12 h-12 ${item.color} rounded-lg flex items-center justify-center`}>
                      <item.icon className="text-white" size={20} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{item.title}</h4>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </div>    
                ))}
              </div>
              
              <div className="text-center animate-fade-in-up animation-delay-400">
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="bg-gradient-to-br from-cyan-500 to-blue-500 rounded-lg p-4 text-white text-center hover:scale-105 transition-transform">
                      <div className="text-sm font-semibold">API</div>
                    </div>
                    <div className="bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg p-4 text-white text-center hover:scale-105 transition-transform">
                      <div className="text-sm font-semibold">SDK</div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-500 to-indigo-500 rounded-lg p-4 text-white text-center hover:scale-105 transition-transform">
                      <div className="text-sm font-semibold">Plug N Play</div>
                    </div>
                    <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-lg p-4 text-white text-center hover:scale-105 transition-transform">
                      <div className="text-sm font-semibold">Analytics</div>
                    </div>
                  </div>
                  <div className="text-xs text-gray-500">Integrated Platform</div>
                </div>
              </div>
              
              <div className="space-y-6">
                {[
                  { icon: CheckCircle, title: "Reports & Analytics", description: "Comprehensive reporting", color: "bg-green-500" },
                  { icon: Users, title: "Notification Management", description: "Real-time notifications", color: "bg-purple-500" },
                  { icon: Zap, title: "Security & Compliance", description: "Enterprise-grade security", color: "bg-orange-500" }
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-4 animate-slide-in-right" style={{animationDelay: `${index * 200}ms`}}>
                    <div className={`w-12 h-12 ${item.color} rounded-lg flex items-center justify-center`}>
                      <item.icon className="text-white" size={20} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{item.title}</h4>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
     
       {/* CTA Section - Dark Theme */}
      <section className="py-20 bg-gray-900 relative overflow-hidden">
        {/* Background Animation */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 left-20 w-96 h-96 bg-cyan-400 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-pulse animation-delay-2000"></div>
        </div>
        
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 animate-fade-in-up">
            Power Your Technology
            <br />
            Services with Our
            <br />
            <span className="text-cyan-400">State of the Art</span>
            <br />
            Solutions
          </h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto animate-fade-in-up animation-delay-200">
            Variety of APIs and SDK solutions for your developers, so it
            can be integrated seamlessly to our value-added
            modules to improve your technology capabilities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-400">
            <a href="/Contact" className="flex items-center">
            <button className="bg-cyan-500 text-white px-8 py-3 rounded-lg hover:bg-cyan-600 transition-colors font-semibold transform hover:scale-105">
              Get Started
            </button>
            </a>
            
            {/* <button className="border border-gray-600 text-gray-300 hover:text-white hover:border-gray-400 px-8 py-3 rounded-lg transition-colors font-semibold">
              Learn More
            </button> */}
          </div>
        </div>
      </section>
        {/* Platform Section */}
      {/* Products Section */}
      <section className="py-20 bg-white" id="products">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 animate-in slide-in-from-bottom duration-1000">
              Products <span className="text-cyan-500">at a Glance</span>
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: Building, title: "Enterprise Solutions", desc: "Comprehensive enterprise-grade solutions for large-scale operations.", gradient: "from-cyan-500 to-blue-500" },
              { icon: Users, title: "Team Collaboration", desc: "Advanced collaboration tools for distributed teams and workflows.", gradient: "from-green-500 to-emerald-500" },
              { icon: Shield, title: "Security Solutions", desc: "Advanced security measures and compliance management systems.", gradient: "from-purple-500 to-indigo-500" },
              { icon: FileText, title: "Analytics Platform", desc: "Real-time analytics and reporting for data-driven decisions.", gradient: "from-orange-500 to-red-500" }
            ].map((product, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 animate-in slide-in-from-bottom duration-1000" style={{ animationDelay: `${index * 200}ms` }}>
                <div className={`w-16 h-16 bg-gradient-to-br ${product.gradient} rounded-lg flex items-center justify-center mb-6 transform hover:rotate-12 transition-transform duration-300`}>
                  <product.icon className="text-white" size={24} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{product.title}</h3>
                <p className="text-gray-600 mb-4">{product.desc}</p>
                {/* <a href="#" className="text-cyan-500 hover:text-cyan-600 font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all">
                  Learn More <ChevronRight size={16} />
                </a> */}
              </div>
            ))}
          </div>
        </div>
      </section>  
<Footer/>
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes fade-in-left {
          0% { opacity: 0; transform: translateX(-30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes fade-in-right {
          0% { opacity: 0; transform: translateX(30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-left {
          0% { opacity: 0; transform: translateX(-20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-right {
          0% { opacity: 0; transform: translateX(20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animate-fade-in-left {
          animation: fade-in-left 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 0.8s ease-out forwards;
        }
        
        .animate-slide-in-left {
          animation: slide-in-left 0.6s ease-out forwards;
        }
        
        .animate-slide-in-right {
          animation: slide-in-right 0.6s ease-out forwards;
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        
        .animation-delay-200 {
          animation-delay: 200ms;
        }
        
        .animation-delay-400 {
          animation-delay: 400ms;
        }
        
        .animation-delay-600 {
          animation-delay: 600ms;
        }
        
        .animation-delay-800 {
          animation-delay: 800ms;
        }
        
        .animation-delay-1000 {
          animation-delay: 1000ms;
        }
        
        .animation-delay-2000 {
          animation-delay: 2000ms;
        }
        
        .animation-delay-4000 {
          animation-delay: 4000ms;
        }
      `}</style>
    </div>
    
  );
};

export default EngagementModel;